import api from "Services/API";
import { UploadFinancialReportProps } from "./FinancialService.props";
import { FormData as FD } from "models/Form";
import { ListResponseType } from "Services/Share.props";
import { FinancialPeriodTypes } from "models/FinancialPeriods";

export const getCloseFinancialPermission = (cycleId: number) => {
    return api.get<{ status: string }>(
        `/admin/financial-period/${cycleId}/close`
    );
};

export const closeCycleRequest = (cycleId: number) => {
    return api.put(`/admin/financial-period/${cycleId}/close`);
};

export const getSingleCycleData = (pageId: number | undefined) => {
    return api.get<FD>(`/admin/financial-period/${pageId}`);
};

export const getNewFinancialCycle = () => {
    return api.get(`/admin/financial-period/new`);
};

export const updateFinancialCycle = ({
    isPost,
    body,
}: {
    isPost: boolean;
    body: FD;
}) => {
    if (isPost) {
        return api.post(`/admin/financial-period`, body);
    }
    return api.put(`/admin/financial-period`, body);
};

export const uploadFinanceRecord = (req: UploadFinancialReportProps) => {
    return api.post(
        `/admin/upload-finance-report/${req.vendorId}/${req.date}`,
        req.data
    );
};
export const getFinancialPeriods = () => {
    return api.get<ListResponseType<FinancialPeriodTypes>>(
        `/admin/financial-period`
    );
};

export const getFinancialPeriodDetail = ({ id }: { id: string }) => {
    return api.get(`/admin/financial-period/${id}`);
};

export const uploadFinancialReport = ({
    body,
    id,
}: {
    body: FormData;
    id: string;
}) => {
    return api.post(`/admin/financial-period-report/${id}`, body);
};

export const saveFilePreviewFInancial = ({
    id,
    fileName,
}: {
    id: string;
    fileName: string;
}) => {
    return api.put(`/admin/financial-period/${fileName}/save/${id}`);
};

export const getAggregationModalDetail = ({
    id,
    vendorId,
}: {
    id: string;
    vendorId: string;
}) => {
    return api.get(`/admin/financial-period/${id}/accepted/${vendorId}`);
};

export const getPerVendorFinancialPeriodExcel = ({
    id,
    vendorId,
}: {
    id: string;
    vendorId: string;
}) => {
    return api.get(`/admin/financial-period/${id}/accepted-excel/${vendorId}`);
};
